module.exports = __webpack_public_path__ + "static/tenth-of-december-5b3c5724dc43470b3fb763d73e734b60.jpg";